/**
 * **NOTE** The component in this file is a direct copy of the styles found at:
 * `src/modules/templateEditor/EditPush/`.
 *
 * Like everything else in this module, this work exists under the assumption that it is temporary.
 * We _should_ be using the templateEditor module's preview for this module, but the current template diff
 * module does not fetch its data from grapqhl, a necessity for the templateEdit preview.
 */

import { IosPlaceholder } from 'ui/icons/devices/IosPlaceholder';
import {
  NotificationBubbleWrapper,
  NotificationBubbleIosContentHeaderSender,
  NotificationContentWrapper,
  NotificationBubbleIosContentBody,
  NotificationBubbleIosContent,
  NotificationAttachmentWrapper,
  NotificationAttachmentIos,
  NotificationBubbleIos,
  NotificationPlaceholder,
  NotificationBubbleIosContentBodyMsg,
  NotificationBubbleIosContentHeader,
} from './ContentPreviewPush.styled';
import { MAX_CHAR_LIMIT } from './constants';
import { truncateText } from './utils';
import type { TemplateDiffContentPush } from '../../../types';

type NotificationIosProps = TemplateDiffContentPush;

export const NotificationIos = ({ title, message, attachmentUrlIos }: NotificationIosProps) => {
  return (
    <NotificationBubbleWrapper data-test="template-diff-push-preview-ios">
      <NotificationBubbleIos>
        <NotificationPlaceholder>
          <IosPlaceholder height={24} width={24} />
        </NotificationPlaceholder>
        <NotificationBubbleIosContent>
          <NotificationBubbleIosContentHeader>
            <NotificationBubbleIosContentHeaderSender>
              {title}
            </NotificationBubbleIosContentHeaderSender>
          </NotificationBubbleIosContentHeader>
          <NotificationContentWrapper>
            <NotificationBubbleIosContentBody>
              <NotificationBubbleIosContentBodyMsg>
                {truncateText(message, MAX_CHAR_LIMIT.ios)}
              </NotificationBubbleIosContentBodyMsg>
            </NotificationBubbleIosContentBody>
            {attachmentUrlIos && (
              <NotificationAttachmentWrapper data-test="template-diff-push-preview-ios-image">
                <NotificationAttachmentIos src={attachmentUrlIos} alt="IOS Push Image" />
              </NotificationAttachmentWrapper>
            )}
          </NotificationContentWrapper>
        </NotificationBubbleIosContent>
      </NotificationBubbleIos>
    </NotificationBubbleWrapper>
  );
};
